// import React from 'react'
import Box, { Props } from 'react-raster';
import { theme } from "src/config";
import styled, { css } from "styled-components";
interface PaperProps extends Props {
  $center?:       boolean;
  $rounded?:      boolean;
  $noBackground?: boolean;
  $noShadow?:     boolean;
  $noStyling?:    boolean;
  $padding?:      string;
  $className?:    string;
  $marginLeft?:   string;
  $marginRight?:  string;
}

export const Paper = styled(Box).attrs( (props: PaperProps) => ({
  $noBackground: props.$noBackground,
  $center:       props.$center == null ? true : props.$center,
  $rounded:      props.$rounded == null ? true : props.$rounded,
}))`
  border-radius:    ${(props: PaperProps) => props.$rounded ?  '0.4rem' : ''};
  background-color: ${(props: PaperProps) => props.$noBackground ?  'transparent' : theme.color.white};
  padding:          ${(props: PaperProps) => props.$padding ?  props.$padding : '2rem'};
  margin:           ${(props: PaperProps) => props.$center ?  '0 auto' : undefined};
  margin-left:      ${(props: PaperProps) => props.$marginLeft ? props.$marginLeft : undefined};
  margin-right:      ${(props: PaperProps) => props.$marginRight ? props.$marginRight : undefined};
  ${(p) => p.$noShadow ? css`outline: 1px solid ${theme.color.secondaryBorder};` : css`box-shadow:${theme.boxShadow.medium};`}
  ${(p) => p.$noStyling && css`outline: none; box-shadow: none; background: transparent;`}
`;

export const DivPaper = styled.div.attrs( (props: PaperProps) => ({
  $noBackground: props.$noBackground,
  $center:       props.$center == null ? true : props.$center,
  $rounded:      props.$rounded == null ? true : props.$rounded,
}))`
  border-radius:    ${(props: PaperProps) => props.$rounded ?  '0.4rem' : ''};
  background-color: ${(props: PaperProps) => props.$noBackground ?  'transparent' : theme.color.white};
  padding:          ${(props: PaperProps) => props.$padding ?  props.$padding : '2rem'};
  margin:           ${(props: PaperProps) => props.$center ?  '0 auto' : undefined};
  margin-left:      ${(props: PaperProps) => props.$marginLeft ? props.$marginLeft : undefined};
  margin-right:      ${(props: PaperProps) => props.$marginRight ? props.$marginRight : undefined};
  ${(p) => p.$noShadow ? css`outline: 1px solid ${theme.color.secondaryBorder};` : css`box-shadow:${theme.boxShadow.medium};`}
  ${(p) => p.$noStyling && css`outline: none; box-shadow: none; background: transparent;`}
`;